<template>
  <div class="banner-wrap dg-no-photo">
    <div class="input-box">
      <div class="search-btn"></div>
      <input type="text" v-model="searchStr" @click="toSearch()" placeholder="请输入想要查找的内容" readonly/>
    </div>
    <van-swipe :autoplay="3000" indicator-color="white" v-if="bannerList">
      <van-swipe-item v-for="(item,index) in bannerList" :key="index" >
        <router-link :to="{path:'/product-detail',query:{id:item.comId}}" >
          <img :src="item.adImage[0].url" alt width="100%" v-if="item.adImage.length>0">
        </router-link>
      </van-swipe-item>
    </van-swipe>
    <search-popup ref="searchPopup"></search-popup>
  </div>
</template>
<script>
  import SearchPopup from '@/components/search-popup'
export default {
  data() {
    return {
      searchStr: ''
    }
  },
  components: {
    SearchPopup
  },
  props: ["bannerList"],
  methods: {
    toSearch () {
      this.$refs.searchPopup.open()
    }
  }
};
</script>
<style lang="scss">
.banner-wrap {
  width: 100%;
  height: 380px;
  position: relative;
  .van-swipe{
    width: 100%;
    height: 100%;
    img{
      width: 100%;
      height: 100%;
    }
    .van-swipe__indicator{
      width: 44px!important;
      height: 8px!important;
      border-radius: 4px!important;
      background: #ccc!important;
      opacity: 1!important;
    }
    .van-swipe__indicator--active{
      background: $btn01!important;
    }
  }
  .input-box{
    display: flex;
    width: 620px;
    height: 68px;
    border-radius: 34px;
    padding-left: 30px;
    padding-right: 30px;
    margin-left: -310px;
    background: rgba(255,255,255,0.85);
    left: 50%;
    top: 20px;
    box-shadow: 2px 2px 16px rgba(0,0,0,0.08);
    z-index: 999;
    position: absolute;
  }
  .search-btn{
    width: 40px;
    height: 100%;
    background-image: url("../../../assets/images/search-icon.png");
    background-size: 40px 40px;
    background-repeat: no-repeat;
    background-position: 0 14px;
  }
  input{
    flex: 1;
    font-size: 28px;
    color: $fc03;
    padding-left: 10px;
    background: none;
  }
  .swiper-container {
    width: 100%;
    height: 100%;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
</style>
